import React, { ReactNode, useEffect, useState } from 'react';
import { Box, BoxProps } from '@mui/material';
import { TableCellProps } from '@mui/material/TableCell';

import Header from './components/Header';
import TitleUsers from './components/TitleUsers';
import TitleProject from './components/TitleProject';
import { ProjectTable, UserTable } from './components';
import { useGetMe } from '../../graphql/query/hooks/useGetMe';
import { useGetProjectsLazyQuery } from '../../graphql/query/__generated__/getProjects';

export interface HeaderCell {
  title: string;
  containerProps?: TableCellProps;
}

export interface BoxCell {
  val: string | ReactNode;
  containerProps?: BoxProps;
}
export interface TableCellsValue {
  cellsValues: Array<BoxCell>;
}

export const Profile = () => {
  const { me } = useGetMe();
  const [runGetProjects, { data }] = useGetProjectsLazyQuery();
  const [getUserId, setGetUserId] = useState('');

  const handlerGetUserId = (userId: string) => {
    setGetUserId(userId);
  };

  const isAdmin: boolean | undefined = me?.is_admin;
  const isMeProject: boolean | undefined = getUserId === me?.id;

  useEffect(() => {
    if (me) {
      setGetUserId(me?.id);
      runGetProjects({ variables: { user_id: me?.id } }).then();
    }
  }, [me]);

  useEffect(() => {
    if (getUserId) {
      runGetProjects({ variables: { user_id: getUserId } }).then();
    }
  }, [getUserId]);

  return (
    <>
      <Box bgcolor="#F1F3F8">
        <Header userName={me?.name || ''} />
        <Box
          width="100%"
          display="flex"
          padding="40px"
          alignItems="center"
          flexDirection="column"
          boxSizing="border-box"
          justifyContent="center"
        >
          {isAdmin && (
            <>
              <Box width="100%">
                <TitleUsers />
              </Box>
              <Box width="100%" mb={20}>
                <UserTable getUserId={handlerGetUserId} data={data} />
              </Box>
            </>
          )}
          <TitleProject getUserId={handlerGetUserId} isMeProject={isMeProject} userId={getUserId} />
          <Box width="100%">
            <ProjectTable data={data} />
          </Box>
        </Box>
      </Box>
    </>
  );
};
